var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const moment_1 = __importDefault(require("moment"));
const Config_1 = __importDefault(require("../config/Config"));
let lang = Config_1.default.SiteLanguage;
if (lang === 'en') {
    lang += '-gb';
}
require(`moment/locale/${lang}`);
class DateUtils {
    static format(date) {
        return moment_1.default.utc(date).locale(Config_1.default.SiteLanguage).format(Config_1.default.DateFormat);
    }
    static parse(date) {
        return moment_1.default(date, Config_1.default.DateFromFormat);
    }
}
exports.default = DateUtils;
